import type { AppLocale } from '@/i18n';
import { formatDualDate, parseIsoDate } from '@/shared/lib/dates';

/** Minimal date pair shared by coverage requests and matched-feed rows. */
export interface RequestDates {
  readonly startDate: string;
  readonly endDate: string;
}

/** Dual Hijri/Gregorian text for a request's date(s). */
export function coverageDatesText(locale: AppLocale, request: RequestDates): string {
  const start = formatDualDate(parseIsoDate(request.startDate), locale);
  if (request.startDate === request.endDate) return start;
  const end = formatDualDate(parseIsoDate(request.endDate), locale);
  return `${start} → ${end}`;
}
